import EditRecurringTaskPage from './EditRecurringTaskPage';

export default EditRecurringTaskPage;
